import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { SecurityDepositActionValidation } from 'uplisting-frontend/validations';

export default class SecurityDepositActionRepositoryService extends BaseRepositoryService<
  ModelRegistry['security-deposit-action']
> {
  recordName = 'security-deposit-action';
  implementMethods = ['createRecord', 'buildChangeset'];

  validation = SecurityDepositActionValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/security-deposit-action': SecurityDepositActionRepositoryService;
  }
}
